import styled from 'styled-components';
import { CssFuncs } from '../../../../foundation/css/css.funcs';

const Mask = styled.div.withConfig({
  componentId: 'popup-controller_mask',
  displayName: 'PopupController.Mask',
})`
  ${CssFuncs.css.absolute({ xy: '0px' })}
`;

export const PopupControllerStyle = {
  Mask,
};
